import { Route } from 'react-router-dom';

import { AppLayout } from '../component/layout/AppLayout';
import { Backlog } from '../component/page/backlog/Backlog';
import { Clients } from '../component/page/clients/Clients';
import { Employees } from '../component/page/employees/Employees';
import { Login } from '../component/page/login/Login';
import { NotFound } from '../component/page/not-found/NotFound';
import { Reports } from '../component/page/reports/Reports';
import { Services } from '../component/page/services/Services';
import { Settings } from '../component/page/settings/Settings';
import { Tasks } from '../component/page/tasks/Tasks';

import { ProtectedRoute } from './ProtectedRoute';
import { ROUTE_PATH } from './utils';

export const appRoutes = () => (
  <Route errorElement={<NotFound />} path="/">
    <Route
      exact
      path={ROUTE_PATH.TASKS}
      element={
        <ProtectedRoute>
          <AppLayout title="Tasks">
            <Tasks />
          </AppLayout>
        </ProtectedRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.CLIENTS}
      element={
        <ProtectedRoute>
          <AppLayout title="Clients">
            <Clients />
          </AppLayout>
        </ProtectedRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.SERVICES}
      element={
        <ProtectedRoute>
          <AppLayout title="Services">
            <Services />
          </AppLayout>
        </ProtectedRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.EMPLOYEES}
      element={
        <ProtectedRoute>
          <AppLayout title="Employees">
            <Employees />
          </AppLayout>
        </ProtectedRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.REPORTS}
      element={
        <ProtectedRoute>
          <AppLayout title="Reports">
            <Reports />
          </AppLayout>
        </ProtectedRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.SETTINGS}
      element={
        <ProtectedRoute>
          <AppLayout title="Settings">
            <Settings />
          </AppLayout>
        </ProtectedRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.BACKLOG}
      element={
        <ProtectedRoute>
          <AppLayout title="Backlog">
            <Backlog />
          </AppLayout>
        </ProtectedRoute>
      }
    />
    <Route exact path={ROUTE_PATH.LOGIN} element={<Login />} />
  </Route>
);
